var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99989 7.11111C9.96357 7.11111 11.5554 5.51924 11.5554 3.55556C11.5554 1.59188 9.96357 0 7.99989 0C6.03621 0 4.44434 1.59188 4.44434 3.55556C4.44434 5.51924 6.03621 7.11111 7.99989 7.11111Z",
    fill: "#F7931E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.16699 13.3333C3.16699 10.664 5.33095 8.5 8.00033 8.5C10.6697 8.5 12.8337 10.664 12.8337 13.3333V15.5H3.16699V13.3333Z",
    stroke: "#1E334E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.7804fab70a0ea648732a36e72eb96058.svg";
export { ForwardRef as ReactComponent };